import * as PIXI from "pixi.js"
import TextureManager from "../../managers/TextureManager";


export default class FireworkBody extends PIXI.Sprite {
  name: string;
  constructor(index: number) {
    super();
    this.name = this.generateFireworkPath(index);
    this.x = 0;
    this.y = 0;
    this.width = 125;
    this.height = 125;
    this.anchor.set(.5);
    this.addTexture();
  }
  generateFireworkPath = (x: number) => `./images/fireworks/firework-${x}.png`;
  addTexture() {
    const texture = TextureManager.getTexture(this.name);
    this.texture = texture;
  }
}